import TextField from "./TextField";
import MuiAutoComplete from "@mui/material/Autocomplete";
import { get } from "lodash";

export default function Autocomplete({
  label,
  name,
  defaults,
  options,
  formikProps,
  placeholder,
  value = "",
  required = false,
  ...props
}) {
  var initialValue = "";
  let values = value ? value : get(formikProps?.values, name, []);

  if (options?.length > 0) {
    initialValue = options?.find(
      (option) => option[defaults.primaryKey] === values
    );
  }

  if (!initialValue) {
    initialValue = {
      [defaults.primaryKey]: "",
    };
  }

  return (
    <MuiAutoComplete
      freeSolo
      fullWidth
      size="small"
      forcePopupIcon={true}
      options={options}
      value={initialValue}
      getOptionLabel={(option) => get(option, defaults.displayLabel, "")}
      renderOption={(props, option, { selected }) => (
        <li {...props} style={{ fontSize: "18px", cursor: "pointer" }}>
          {option[defaults.displayLabel]}
        </li>
      )}
      onChange={(_, value) => {
        formikProps.setValues((prevValue) => ({
          ...prevValue,
          [name]: value[defaults.primaryKey],
        }));
      }}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          placeholder={
            get(formikProps?.values, name, []).length === 0 ? placeholder : ""
          }
          label={label}
          name={name}
          error={Boolean(
            get(formikProps, "touched." + name) &&
              get(formikProps, "errors." + name)
          )}
          helperText={
            get(formikProps, "touched." + name) &&
            get(formikProps, "errors." + name)
          }
          onBlur={get(formikProps, "handleBlur")}
        />
      )}
    />
  );
}
